module.exports = __webpack_public_path__ + "img/login-footer.190351f5.png";